import Icon from '../components/Icon.vue'

Icon.register({"unlock-alt":{"width":1152,"height":1792,"paths":[{"d":"M1056 768q40 0 68 28t28 68v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-320q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5q0 26-19 45t-45 19h-64q-26 0-45-19t-19-45q0-106-75-181t-181-75-181 75-75 181v320h736z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/unlock-alt.js
// module id = 1948
// module chunks = 0